import React from 'react';
import testIds from '@smart-tv/e2e/shared/variables';
import ProgressBar from '@smart-tv/components/progress-bar/progress-bar';
import useInterval from '@smart-tv/hooks/use-interval';
import getLiveProgress from '@smart-tv/utils/content/get-live-progress';
import styles from './player-channel.module.scss';

const UPDATE_PROGRESS_INTERVAL = 10000;

interface Props {
  startTime: Date;
  endTime: Date;
}

export const PlayerChannelProgressBar: React.FC<Props> = (props: Props) => {
  const { startTime, endTime } = props;

  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    setProgress(getLiveProgress(startTime, endTime));
  }, [startTime, endTime]);

  useInterval(() => setProgress(getLiveProgress(startTime, endTime)), UPDATE_PROGRESS_INTERVAL);

  return (
    <ProgressBar
      className={styles['player-channel-content__progress-bar']}
      height={8}
      color="success"
      value={progress}
      data-testid={testIds.player.channels.channel.progress}
    />
  );
};

export default React.memo(PlayerChannelProgressBar);
